export enum UsedFeatureFlags {
  HIDE_SALES_TOOLS_LEASING_RATE = `hide-sales-tools-leasing-rate`,
  ENABLE_ENERGYLABEL_MODAL = `enable-energylabel-modal`,
  ENABLE_MODEL_YEAR = `enable-model-year`,
  ENABLE_STOCK_SEARCH_FILTER_V2 = `enable-stock-search-filter-v2`,
  HIDE_PAYMENT_CALCULATOR = `hide-payment-calculator`,
}

export const allowedFacets = [
  `model`,
  `line`,
  `exterior`,
  `interior`,
  `battery`,
  `priceRange`,
  `earliestBeautifiedLeadTime`,
  `drivetrain`,
  `standardEquipment`,
  `productBadge`,
];

export const allowedQueryParamFacets = [`model`, `line`, `productBadge`];
